import { styled } from '@mui/material'
import { useMemo } from 'react'

const StyledSpacer = styled('div')({
  backgroundColor: 'transparent',
})

interface SpacerProps {
  maxHeight?: number | string
  maxWidth?: number | string
  minHeight?: number | string
  minWidth?: number | string
  className?: string
}

/**
 * Basic styled component used to space out to other components.
 * When maxHeight & maxWidth props are omitted, defaults to filling all remaining space.
 * When minHeight & minWidth props are omitted, will shrink to 0px before content overflows,
 * wraps, or scrolls.
 *
 * @example
 * <div style={{display: 'flex', flexDirection: 'row'}}>
 *    <div>This should hug the left</div>
 *      <Spacer />
 *    <div>This should hug the right</div>
 * </div>
 */
export function Spacer({ maxHeight, maxWidth, minHeight, minWidth, className }: SpacerProps) {
  const styles = useMemo(
    () => ({
      maxHeight,
      maxWidth,
      minHeight,
      minWidth,
      flex: 1,
    }),
    [maxHeight, maxWidth, minHeight, minWidth]
  )
  return <StyledSpacer className={className} style={styles} />
}
